module.exports = __webpack_public_path__ + "img/normal-nan.9b2e2a0b.png";